export type LanguageId = "de" | "en";
export const SUPPORTED_LANGUAGES = [
  { id: "de", label: "Deutsch" },
  { id: "en", label: "English" },
];
